/**
 * Filters questions/options by API `conditionalExpression` using json-logic.
 *
 * Belongs here: condition evaluation shared by strategy and preferences flows.
 * Does not belong here: visibility list building (see visibleQuestions.ts).
 */
import jsonLogic from 'json-logic-js'

export type AnswersMap = Record<string, string | number | string[]>

/**
 * @param expression — JSON logic string from API; empty means always visible
 * @param answers — current draft answers map (question id → value)
 */
export function evaluateCondition(expression: string, answers: AnswersMap): boolean {
  if (expression == null || typeof expression !== 'string' || expression.trim() === '') return true
  try {
    const rule = JSON.parse(expression) as object
    // json-logic expects scalar vars; multi-select uses first selected id for conditions
    const normalized: Record<string, string | number | null> = {}
    for (const [key, value] of Object.entries(answers ?? {})) {
      normalized[key] = Array.isArray(value) ? (value[0] ?? null) : (value ?? null)
    }
    const result = jsonLogic.apply(rule, normalized as Record<string, unknown>)
    if (typeof result === 'boolean') return result
    return result != null && result !== ''
  } catch {
    return false
  }
}
